import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { resultsThunks, selectedActions, dealersSetThunks } from 'shared/actions/searchForm';
import { injectIntl, intlShape } from 'react-intl';
import { partsFormAsyncSetActions } from 'shared/actions/partsForm';
import { pluralize } from 'shared/modules';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import SearchFormBottom from './SearchFormBottom/SearchFormBottom';
import Sto from './StoPanel';
import FirmsAllPanel from './FirmsAllPanel';

import s from './SearchFirms.css';

class SearchFirms extends React.Component {
  static propTypes = {
    selectedActions: PropTypes.shape().isRequired,
    currentPath: PropTypes.string,
    intl: intlShape.isRequired,
    partsFormVocabulary: PropTypes.shape(),
    action: PropTypes.shape(),
  };
  static defaultProps = {
    formState: {},
    action: {},
    results: {},
    partsFormVocabulary: {},
    selectedActions: {},
    expandable: true,
    searchable: true,
    withLocation: true,
    isLoading: false,
    currentPath: '/',
  };

  state = {
    collapsed: true,
    type: 'all',
    region: 'all',
  };

  handleClick = () => {};

  render() {
    const {
      currentPath,
      intl,
      action,
      partsFormVocabulary: { url, query = '' },
      selectedActions: { clearForm },
      partsFormVocabulary: { count: countFilter },
    } = this.props;
    let companyQuery = query.split('&').filter(item => item !== 'page=1');
    if (companyQuery.length) companyQuery = companyQuery.join('&'); // tasks seo_29.07

    const { collapsed, type } = this.state;
    const text = pluralize('компан', Number(countFilter), ['ий', 'ия', 'ии']);
    const defaultCardType = intl.formatMessage(
      {
        id: text,
      },
      { count: countFilter },
    );
    return (
      <div className={s.root}>
        {(() => {
          if (/\/sto(\/|\?)/.test(currentPath)) {
            return <Sto {...this.props} collapsed={collapsed} />;
          }
          return <FirmsAllPanel {...this.props} collapsed={collapsed} />;
        })()}
        <SearchFormBottom
          onClickBottom={this.handleClick}
          count={countFilter}
          collapsed={collapsed}
          type={type}
          url={`${url}?${companyQuery}`}
          expandable={false}
          searchable={false}
          handleClick={this.handleClick}
          handleClearForm={() => {
            clearForm();
            action.partsFormAsyncSetActions({ count: true });
            this.props.action.resultsThunks();
          }}
          cardTypes={'' || defaultCardType}
          isLoading={false}
        />
      </div>
    );
  }
}
const mapStateToProps = ({ searchForm = {}, globals, history: historyPath, partsForm }) => ({
  formState: searchForm.selected,
  formResults: searchForm.results,
  formData: searchForm.data,
  formVocabulary: searchForm.vocabulary,
  //
  currentPath: (historyPath && historyPath.currentPath) || '',
  counts: searchForm && searchForm.counts,
  location: globals ? globals.location : null,
  results: searchForm.results ? searchForm.results : {},
  partsFormVocabulary: partsForm.vocabulary ? partsForm.vocabulary : {},
});

const mapDispatchToProps = dispatch => ({
  selectedActions: {
    set: bindActionCreators(
      {
        ...selectedActions.set,
        ...dealersSetThunks,
      },
      dispatch,
    ),
    toggle: bindActionCreators(selectedActions.toggle, dispatch),
    clear: bindActionCreators(selectedActions.clear),
    clearForm: bindActionCreators(dealersSetThunks.clearSelected, dispatch),
  },
  action: bindActionCreators(
    {
      resultsThunks: resultsThunks.searchFirmsResults,
      partsFormAsyncSetActions: partsFormAsyncSetActions.company,
    },
    dispatch,
  ),
});
export default withStyles(s)(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(injectIntl(SearchFirms)),
);



// WEBPACK FOOTER //
// ./src/desktop/components/SearchPanel/SearchFirms.js